import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useTheme } from "../../contexts/ThemeContext";

import ActionDropdown from "../../components/ActionDropDown/ActionDropdown";

import "../LayoutCss/topbar.css";

const APP_NAME = "FurniSense";

const prettifyModuleName = (value = "") => {
  return String(value)
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const Topbar = () => {
  const location = useLocation();

  const { user, logout, pages } = useAuth();
  const { theme, toggleTheme } = useTheme();

  // Page name from Redux
  const pageName = useSelector((state) => state.page.currentPageName);

  // First letter avatar fallback
  const firstLetter = user?.user_name?.charAt(0)?.toUpperCase() || "U";

  const getModuleNameFromPath = () => {
    const pathname = location.pathname;

    if (pathname.endsWith("/dashboard")) {
      return "Dashboard";
    }

    if (pathname === "/superadmin/rbac") {
      return "RBAC";
    }

    const pageSegment = pathname.split("/page/")[1];

    if (pageSegment) {
      const baseSegment = pageSegment.split("/")[0];
      const matchedPage = pages?.find((p) => p.model_name === baseSegment);
      return matchedPage?.page_name || prettifyModuleName(baseSegment);
    }

    return pageName || "Dashboard";
  };

  const moduleName = getModuleNameFromPath();

  useEffect(() => {
    document.title = `${APP_NAME} | ${moduleName}`;
  }, [moduleName]);

  // Profile dropdown menu
  const profileMenu = [
    {
      label: "Settings",
      icon: "gear",
      onClick: () => {
        console.log("Open Settings");
      },
    },

    {
      label: "Logout",
      icon: "box-arrow-right",
      onClick: logout,
    },
  ];

  return (
    <div className="topbar">
      {/* LEFT SIDE -> PAGE NAME */}

      <div className="topbar-left">
        <h3 className="topbar-page-title">{moduleName}</h3>
      </div>

      {/* RIGHT SIDE -> PROFILE */}

      <div className="topbar-right">
        {/* Theme Toggle */}
        {/* <button
          className="topbar-theme-toggle"
          onClick={toggleTheme}
          title={theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
        >
          <i className={`bi bi-${theme === "dark" ? "sun" : "moon"}`} />
        </button> */}

        {/* User name */}

        <span className="topbar-username">{user?.email}</span>

        {/* Profile Dropdown */}

        <ActionDropdown items={profileMenu}>
          <div className="topbar-avatar">
            {user?.profile_image ? (
              <img src={user.profile_image} alt="profile" />
            ) : (
              firstLetter
            )}
          </div>
        </ActionDropdown>
      </div>
    </div>
  );
};

export default Topbar;
